// Shared by the public reader and its build-time HTML, so navigation cannot
// replace a pack's search metadata with the home page's metadata.
export function previewSeo(packId, pack = {}) {
    const board = packId.startsWith('edexcel') ? 'Edexcel IGCSE English' : packId.startsWith('aqa-') ? 'OxfordAQA IGCSE English Literature' : 'IGCSE English';
    const title = pack.title || packId.replace(/-/g, ' ');
    return {
        title: `${title} — Free Lesson | Between the Lines`,
        description: `Read a free ${board} lesson from ${title} with Danielle. No account needed. Explore close reading and writing practice.`.slice(0, 200),
        canonical: `https://daniellenglish.com/preview/${encodeURIComponent(packId)}`,
    };
}
export const PREVIEW_OFFER = 'Study with Danielle’s guidance, AI Explain in your preferred language, AI Study Partner and essay feedback in eligible packs. AI usage limits apply.';
export const PREVIEW_PURCHASE = 'Create a free account to explore available samples. Full study packs require a separate purchase.';
